import React, { createContext, useContext, useState } from 'react';
import axios, { CancelTokenSource } from 'axios';
import {
    buscarPedidosERP,
    buscarHistoricoPedidoERP,
    buscarItensPedidoERP,
    buscarClientesERP,
    buscarFormaPagamentoERP,
    buscarCondicaoPagamentoERP,
    buscarDerivacoesERP,
    buscarProdutosERP,
    enviarPrePedido,
    atualizarPrePedido,
    consultarPrePedido,
    excluirPrePedido,
    gerarResumoPrePedido,
    enviarPedidoERP,
    buscarTransportadoraERP,
    verificaSaldoPrePedido,
    atualizarResumoPrePedido,
    enviarEmailPedidos
} from '../modules/pedidos/apis/servicePedidoConsulta';

import { buscarPedidosAprovacaoERP, aprovarRecusarPedido, buscarPendenciasPedidos } from '../modules/aprovacao/apis/serviceAprovacao';
import { Toast } from '../themes/components/Toast';
//importing context
import { useLocalStorage } from './LocalStorage';
import {
    PropChildren,
    ArrayHistPedidos,
    ArrayItensPedido,
    Pedido,
    ArrayPedidos,
    SituacoesPedidos,
    TiposPedidos,
    ArrayCondicaoPagamento,
    ArrayFormaPagamento,
    ArrayClientes,
    NovoPedido,
    ArrayDerivacoes,
    ArrayProdutos,
    ResumoPrePedido,
    Transportadora,
    ItemEdicaoNovoPedido
} from '../modules/pedidos/interfaces';
const PedidosContext = createContext({} as PropsContextProvier);


type PropsContextProvier = {
    pedido: Pedido | null,
    situacoes: SituacoesPedidos,
    tiposPedidos: TiposPedidos,
    tiposFrete: { "cod": string, "desc": string }[]
    loadingBuscaPedidosConsulta: boolean,
    pedidosBusca: ArrayPedidos | null,
    novoPedido: NovoPedido,
    itensDigitacaoPedido: ItemEdicaoNovoPedido[],
    idPrePedido: number | undefined,
    setIdPrePedido: React.Dispatch<React.SetStateAction<number | undefined>>,
    setItensDigitacaoPedido: React.Dispatch<React.SetStateAction<ItemEdicaoNovoPedido[]>>,
    setPedido: React.Dispatch<React.SetStateAction<Pedido>>,
    setNovoPedido: React.Dispatch<React.SetStateAction<NovoPedido>>,
    setLoadingBuscaPedidosConsulta: React.Dispatch<React.SetStateAction<boolean>>,
    buscarPedidos: (codcli: string, numped: string, sitped: string, tipped: string, history: any) => Promise<void> | Promise<{ result: string; }> | Promise<unknown> | Promise<void> | void,
    buscarHistoricoPed: (numped: string, codEmp: string, history: any) => Promise<ArrayHistPedidos>,
    buscarItensPedido: (numped: string, codemp: string, history: any) => Promise<ArrayItensPedido>,
    buscarClientes: (nomcli: string, history: any) => Promise<ArrayClientes>,
    buscarFormaPGTO: (codfpg: string, desfpg: string, history: any) => Promise<ArrayFormaPagamento>,
    buscarCondPGTO: (codcpg: string, descpg: string, history: any) => Promise<ArrayCondicaoPagamento>,
    buscarDerivacoes: (codclc: string, history: any) => Promise<ArrayDerivacoes>,
    filtrarProdutos: (find: string, history: any) => Promise<ArrayProdutos>,
    salvarPrePedido: (pedido: NovoPedido, history: any) => Promise<number>,
    updatePrePedido: (pedido: NovoPedido, id: number, history: any) => Promise<boolean>,
    updateResumoPrePedido: (resumo: string, id: number, history: any) => Promise<ResumoPrePedido>,
    getPrePedido: (id: number, history: any) => any,
    deletarPrePedido: (id: number, history: any) => Promise<boolean>,
    gerarResumoParaPrePedido: (id: number, history: any) => Promise<ResumoPrePedido[]>,
    enviarPedidoParaERP: (id: number, history: any) => any,
    buscarTransportadora: (filter: string, history: any) => Promise<Transportadora[]>,
    atualizaSaldoPrePedido: (id: number, history: any) => any,
    enviarPedidosPorEmail: (pedidos: string[], enviacliente: boolean, history: any) => Promise<boolean>
    filtrarPedidosAprovacao: (codcli: string, numped: string, codemp: string, sitped: string, tipped: string, history: any) => Promise<void> | Promise<{ result: string; }> | Promise<unknown> | Promise<void> | void,
    controleAprovacao: (numped: string, codemp: string, obsped: string, tipped: string, history: any) => Promise<string>,
    setPedidosBusca: (pedidos: Pedido[]) => any,
    pendenciasPedidos: (numped: string, codEmp:string, history: any) => Promise<any>,
}

export default function PedidosProvider({ children }: PropChildren) {
    const situacoes = [
        { "cod": 1, "nome": "Aberto Total" },
        { "cod": 2, "nome": "Aberto Parcial" },
        { "cod": 4, "nome": "Liquidado" },
        { "cod": 5, "nome": "Cancelado" }];

    const tiposFrete = [
        { "cod": "C", "desc": "(CIF) Por conta do emitente" },
        { "cod": "F", "desc": "(FOB) Por conta do destinatário" },
        { "cod": "X", "desc": "Sem frete" },
    ]

    const tiposPedidos = ["Imediato", "Programado", "Corte"];
    const [pedidosBusca, setPedidosBusca] = useState<Pedido[]>([]);
    const [idPrePedido, setIdPrePedido] = useState<number>();
    const [itensDigitacaoPedido, setItensDigitacaoPedido] = useState<ItemEdicaoNovoPedido[]>([]);
    const { getFromSessionStorage } = useLocalStorage();
    const [pedido, setPedido] = useState<Pedido>({
        codCpg: "",
        codFpg: "",
        codEmp: "",
        datEmi: "",
        datPrv: "",
        nomCli: "",
        numPed: "",
        qtdOri: "",
        vlrOri: ""
    });
    const [novoPedido, setNovoPedido] = useState<NovoPedido>({
        "empresa": 2,
        "filial": 1,
        "cliente": 0,
        "representante": 0,
        "formapag": "",
        "condpag": 0,
        "observacao": "",
        "cpfcnpj": 0,
        "valor": 0,
        "itens": 0,
        "quantidade": 0,
        "transportadora2": 0,
        "tipofrete": "",
        "tipomoeda": "R",
        "dataentrega": "",
        "nomecliente": "",
        "nomeformapag": "",
        "nomecondpag": "",
        "produtos": []
    });
    const [loadingBuscaPedidosConsulta, setLoadingBuscaPedidosConsulta] = useState<boolean>(true);

    //Tokens de requisições
    const [tokenRequestProduto, setTokenRequestProduto] = useState<any>();
    const [tokenRequestPedidoConsulta, setTokenRequestPedidoConsulta] = useState<any>();
    const [tokenRequestFormaPGTO, setTokenRequestFormaPGTO] = useState<any>();
    const [tokenRequestCondPGTO, setTokenRequestCondPGTO] = useState<any>();
    const [tokenRequestCliente, setTokenRequestCliente] = useState<any>();
    const [tokenRequestDerivation, setTokenRequestDerivation] = useState<any>();
    const [tokenRequestTransp, setTokenRequestTransp] = useState<any>();

    function buscarPedidos(numped: string, codcli: string, sitped: string, tipped: string, history: any) {
        setLoadingBuscaPedidosConsulta(true);
        filtrarPedidos(numped, codcli, sitped, tipped, history);
    }

    async function buscarItensPedido(numped: string, codemp: string, history: any) {
        return new Promise<ArrayItensPedido>((resolve, reject) => {           
            buscarItensPedidoERP(numped, codemp, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(res => {
                    resolve(res instanceof Array ? res : [res]);
                })
                .catch(err => {
                    if (err.error.message !== undefined) {
                        if (err.error.message.includes("cadastro de representante!")) {
                            Toast("error", "Pedidos de representantes não encontrados.");
                        } else if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        } else if (err.error.message.includes("Network Error")) {
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                        } else {
                            Toast("error", "Falha ao consultar itens do pedido " + numped);
                        }
                    } else {
                        Toast("error", "Falha ao consultar itens do pedido " + numped);
                    }
                    reject([]);
                })
        })
    }

    async function buscarClientes(nomcli: string, history: any) {
        const CancelToken = axios.CancelToken;
        let cancelSource: CancelTokenSource | null = null;

        if (tokenRequestCliente !== undefined) {
            tokenRequestCliente.cancel();
        }

        cancelSource = CancelToken.source();
        setTokenRequestCliente(cancelSource);

        return new Promise<ArrayClientes>((resolve, reject) => {
            buscarClientesERP(nomcli, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"), cancelSource?.token)
                .then(res => {
                    resolve(res instanceof Array ? res : [res]);
                    setTokenRequestCliente(undefined);
                })
                .catch(err => {
                    if (axios.isCancel(err.error)) {
                        reject("Cancel");
                    } else {
                        //console.log(err);
                        if (err.error.message !== undefined) {
                            if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                                redirectTo(history, '/login', { from: history.location.pathname });
                            } else if (err.error.message.includes("Network Error")) {
                                Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                                reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            }
                        } else {
                            Toast("error", "Falha ao consultar Cliente");
                        }
                        reject([]);
                    }
                })
        })
    }

    async function buscarTransportadora(filter: string, history: any) {
        const CancelToken = axios.CancelToken;
        let cancelSource: CancelTokenSource | null = null;
        let cod = ""
        let nome = ""

        //Lógica para definir se irá requisitar ao back pelo código ou pelo nome
        if (new RegExp("[0-9]+", 'g').test(filter)) {
            cod = filter;
        } else {
            nome = filter;
        }

        //cancelando tokens antigos e gerando novo token para requisição
        if (tokenRequestTransp !== undefined) {
            tokenRequestTransp.cancel();
        }
        cancelSource = CancelToken.source();
        setTokenRequestTransp(cancelSource);

        return new Promise<Transportadora[]>((resolve, reject) => {
            buscarTransportadoraERP(cod, nome, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"), cancelSource?.token)
                .then(res => {
                    resolve(res instanceof Array ? res : [res]);
                    setTokenRequestTransp(undefined);
                })
                .catch(err => {
                    if (axios.isCancel(err.error)) {
                        reject("Cancel");
                    } else {
                        if (err.error.message !== undefined) {
                            if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                                redirectTo(history, '/login', { from: history.location.pathname });
                            } else if (err.error.message.includes("Network Error")) {
                                Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                                reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            }
                        } else {
                            Toast("error", "Falha ao consultar Transportadora");
                        }
                        reject([]);
                    }
                })
        })
    }

    async function buscarFormaPGTO(codfpg: string, desfpg: string, history: any) {
        const CancelToken = axios.CancelToken;
        let cancelSource: CancelTokenSource | null = null;

        if (tokenRequestFormaPGTO !== undefined) {
            tokenRequestFormaPGTO.cancel();
        }

        cancelSource = CancelToken.source();
        setTokenRequestFormaPGTO(cancelSource);

        return new Promise<ArrayFormaPagamento>((resolve, reject) => {
            buscarFormaPagamentoERP(codfpg, desfpg, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"), cancelSource?.token)
                .then(res => {
                    resolve(res instanceof Array ? res : [res]);
                    setTokenRequestFormaPGTO(undefined);
                })
                .catch(err => {
                    if (axios.isCancel(err.error)) {
                        reject("Cancel");
                    } else {
                        if (err.error.message !== undefined) {
                            if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                                redirectTo(history, '/login', { from: history.location.pathname });
                            } else if (err.error.message.includes("Network Error")) {
                                Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                                reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            }
                        } else {
                            Toast("error", "Falha ao consultar Formas de Pagamento");
                        }
                        reject([]);
                    }
                })
        })
    }

    async function buscarCondPGTO(codcpg: string, descpg: string, history: any) {
        const CancelToken = axios.CancelToken;
        let cancelSource: CancelTokenSource | null = null;

        if (tokenRequestCondPGTO !== undefined) {
            tokenRequestCondPGTO.cancel();
        }

        cancelSource = CancelToken.source();
        setTokenRequestCondPGTO(cancelSource);

        return new Promise<ArrayCondicaoPagamento>((resolve, reject) => {
            buscarCondicaoPagamentoERP(codcpg, descpg, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"), cancelSource?.token)
                .then(res => {
                    resolve(res instanceof Array ? res : [res]);
                    setTokenRequestFormaPGTO(undefined);
                })
                .catch(err => {
                    if (axios.isCancel(err.error)) {
                        reject("Cancel");
                    } else {
                        if (err.error.message !== undefined) {
                            if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                                redirectTo(history, '/login', { from: history.location.pathname });
                            } else if (err.error.message.includes("Network Error")) {
                                Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                                reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            }
                        } else {
                            Toast("error", "Falha ao consultar Condições de Pagamento");
                        }
                        reject([]);
                    }
                })
        })
    }

    async function buscarDerivacoes(codclc: string, history: any) {
        const CancelToken = axios.CancelToken;
        let cancelSource: CancelTokenSource | null = null;

        if (tokenRequestDerivation !== undefined) {
            tokenRequestDerivation.cancel();
        }

        cancelSource = CancelToken.source();
        setTokenRequestDerivation(cancelSource);

        return new Promise<ArrayDerivacoes>((resolve, reject) => {
            buscarDerivacoesERP(codclc, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"), cancelSource?.token)
                .then(res => {
                    resolve(res instanceof Array ? res : [res]);
                    setTokenRequestDerivation(undefined);
                })
                .catch(err => {
                    if (axios.isCancel(err.error)) {
                        reject("Cancel");
                    } else {
                        if (err.error.message !== undefined) {
                            if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                                redirectTo(history, '/login', { from: history.location.pathname });
                            } else if (err.error.message.includes("Network Error")) {
                                Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                                reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            }
                        } else {
                            Toast("error", "Falha ao consultar Derivações");
                        }
                        reject([]);
                    }
                })
        })
    }
    async function buscarHistoricoPed(numped: string, codEmp: string, history: any) {
        return new Promise<ArrayHistPedidos>((resolve, reject) => {
            buscarHistoricoPedidoERP(numped, codEmp, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(res => {
                    resolve(res instanceof Array ? res : [res]);
                })
                .catch(err => {
                    if (err.error.message !== undefined) {
                        if (err.error.message.includes("cadastro de representante!")) {
                            Toast("error", "Pedidos de representantes não encontrados.");
                        } else if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: '/pedidos/consultar' });
                        } else if (err.error.message.includes("Network Error")) {
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                        } else {
                            Toast("error", "Falha ao consultar histórico do pedido " + numped);
                        }
                    } else {
                        Toast("error", "Falha ao consultar histórico do pedido " + numped);
                    }
                    reject([]);
                })
        })
    }

    async function filtrarPedidos(numped: string, codcli: string, sitped: string, tipped: string, history: any) {
        const CancelToken = axios.CancelToken;
        let cancelSource: CancelTokenSource | null = null;

        if (tokenRequestPedidoConsulta !== undefined) {
            tokenRequestPedidoConsulta.cancel();
        }

        cancelSource = CancelToken.source();
        setTokenRequestPedidoConsulta(cancelSource);

        return new Promise<ArrayHistPedidos>((resolve, reject) => {
            buscarPedidosERP(getFromSessionStorage("userlogin"), codcli, numped, sitped, tipped, getFromSessionStorage("logid"), cancelSource?.token)
                .then(result => {
                    setPedidosBusca(result instanceof Array ? result : [result]);
                    setLoadingBuscaPedidosConsulta(false);
                    setTokenRequestPedidoConsulta(undefined);
                })
                .catch(err => {
                    if (axios.isCancel(err.error)) {
                        reject("Cancel");
                    } else {
                        setPedidosBusca([]);
                        if (err.error.message !== undefined) {

                            if (err.error.message.includes("cadastro de representante!")) {
                                Toast("error", "Pedidos de representantes não encontrados.");
                            } else if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                                redirectTo(history, '/login', { from: '/pedidos/consultar' });
                            } else if (err.error.message.includes("Nenhum pedido encontrado")) {
                                Toast("error", "Nenhum pedido encontrado");
                                setLoadingBuscaPedidosConsulta(false);
                            } else if (err.error.message.includes("Network Error")) {
                                Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                                reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            } else {
                                Toast("error", err.error.message);
                            }
                        } else {
                            Toast("error", "Falha ao consultar pedidos.");
                        }
                        setLoadingBuscaPedidosConsulta(false);
                        reject([]);
                    }
                })
        })
    }

    async function filtrarPedidosAprovacao(numped: string, codcli: string, codemp: string, sitped: string, tipped: string, history: any) {
        setLoadingBuscaPedidosConsulta(true);
        return new Promise<ArrayHistPedidos>((resolve, reject) => {
            buscarPedidosAprovacaoERP(getFromSessionStorage("userlogin"), codcli, numped, codemp, sitped, tipped, getFromSessionStorage("logid"))
                .then(result => {
                    setPedidosBusca(result instanceof Array ? result : [result]);
                    setLoadingBuscaPedidosConsulta(false);
                    setTokenRequestPedidoConsulta(undefined);
                })
                .catch(err => {
                    setPedidosBusca([]);
                    if (err !== undefined && err.error !== undefined && err.error.message !== undefined) {
                        if (err.error.message.includes("cadastro de representante!")) {
                            Toast("error", "Pedidos de representantes não encontrados.");
                        } else if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: '/aprovacao' });
                        } else if (err.error.message.includes("Nenhum pedido encontrado")) {
                            Toast("error", "Nenhum pedido encontrado");
                            setLoadingBuscaPedidosConsulta(false);
                        } else if (err.error.message.includes("Network Error")) {
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                        } else {
                            Toast("error", err.error.message);
                        }
                    } else {
                        Toast("error", "Falha ao consultar pedidos.");
                    }
                    setLoadingBuscaPedidosConsulta(false);
                    reject([]);
                })
        })
    }

    async function controleAprovacao(numped: string, codemp: string, obsped: string, tipped: string, history: any) {
        return new Promise<string>((resolve, reject) => {
            aprovarRecusarPedido(numped, codemp, obsped, tipped, getFromSessionStorage("logid"), getFromSessionStorage("userlogin"))
                .then(result => {
                    resolve(result.message);
                })
                .catch(err => {
                    if (err.error.message !== undefined) {
                        if (err.error.message.includes("cadastro de representante!")) {
                            Toast("error", "Pedidos de representantes não encontrados.");
                        } else if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: '/aprovacao' });
                        } else if (err.error.message.includes("Nenhum pedido encontrado")) {
                            Toast("error", "Nenhum pedido encontrado");
                            setLoadingBuscaPedidosConsulta(false);
                        } else if (err.error.message.includes("Network Error")) {
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                        } else {
                            Toast("error", err.error.message);
                        }
                    } else {
                        Toast("error", "Falha ao consultar pedidos.");
                    }
                    setLoadingBuscaPedidosConsulta(false);
                    reject("");
                })
        })
    }
    async function pendenciasPedidos(numped: string, codEmp: string, history: any) {       
        return new Promise<string>((resolve, reject) => {
            buscarPendenciasPedidos(numped, codEmp, getFromSessionStorage("logid"), getFromSessionStorage("userlogin"))
                .then(result => {
                    resolve(result);
                })
                .catch(err => {
                    if (err.error.message !== undefined) {
                        if (err.error.message.includes("cadastro de representante!")) {
                            Toast("error", "Pedidos de representantes não encontrados.");
                        } else if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: '/aprovacao' });
                        } else if (err.error.message.includes("Nenhum pedido encontrado")) {
                            Toast("error", "Nenhum pedido encontrado");
                            setLoadingBuscaPedidosConsulta(false);
                        } else if (err.error.message.includes("Network Error")) {
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                        } else {
                            Toast("error", err.error.message);
                        }
                    } else {
                        Toast("error", "Falha ao consultar pedidos.");
                    }
                    setLoadingBuscaPedidosConsulta(false);
                    reject("");
                })
        })
    }

    async function filtrarProdutos(find: string, history: any) {
        const CancelToken = axios.CancelToken;
        let cancelSource: CancelTokenSource | null = null;

        if (tokenRequestProduto !== undefined) {
            tokenRequestProduto.cancel();
        }

        cancelSource = CancelToken.source();
        setTokenRequestProduto(cancelSource);

        return new Promise<ArrayProdutos>((resolve, reject) => {
            buscarProdutosERP(find.trim(), getFromSessionStorage("userlogin"), getFromSessionStorage("logid"), cancelSource?.token)
                .then(result => {
                    resolve(result instanceof Array ? result : [result]);
                    setTokenRequestProduto(undefined);
                })
                .catch(err => {
                    if (axios.isCancel(err.error)) {
                        reject("Cancel");
                    } else {
                        if (err.error.message !== undefined) {
                            if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                                redirectTo(history, '/login', { from: history.location.pathname });
                            } else if (err.error.message.includes("Token inválido")) {
                                redirectTo(history, '/login', { from: history.location.pathname });
                            } else if (err.error.message.includes("Nenhum produto encontrado")) {
                                Toast("error", "Nenhum produto encontrado");
                            } else if (err.error.message.includes("Network Error")) {
                                Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                                reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            }
                        } else {
                            Toast("error", "Falha ao consultar produtos.");
                        }
                        reject([]);
                    }
                })
        })
    }

    async function salvarPrePedido(pedido: NovoPedido, history: any) {
        return new Promise<number>((resolve, reject) => {
            enviarPrePedido(pedido, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(result => {
                    if (result.id !== undefined) {
                        setIdPrePedido(result.id);
                        resolve(result.id);
                    } else {
                        reject(-1);
                    }
                })
                .catch(err => {
                    if (err.error.message !== undefined) {
                        if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        } else if (err.error.message.includes("Token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        } else if (err.error.message.includes("Network Error")) {
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                        }
                    } else {
                        Toast("error", "Falha ao salvar pré-pedido.");
                        if(err.error !== undefined){
                            reject(err.error);
                        }else{
                            reject(err);
                        }
                    }
                })
        })
    }

    async function updatePrePedido(pedido: NovoPedido, id: number, history: any) {
        return new Promise<boolean>((resolve, reject) => {
            atualizarPrePedido(pedido, id, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(result => {
                    if (result !== undefined) {
                        setIdPrePedido(result.id);
                        resolve(true);
                    } else {
                        reject(false);
                    }
                })
                .catch(err => {
                    if (err.error.message !== undefined) {
                        if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        } else if (err.error.message.includes("Token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        } else if (err.error.message.includes("Nenhum produto encontrado")) {
                            Toast("error", "Nenhum produto encontrado");
                        } else if (err.error.message.includes("Network Error")) {
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                        }
                    } else {
                        Toast("error", "Falha ao consultar produtos.");
                    }
                    reject(false);
                })
        })
    }

    async function updateResumoPrePedido(resumo: string, id: number, history: any) {
        return new Promise<ResumoPrePedido>((resolve, reject) => {
            atualizarResumoPrePedido(resumo, id, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(result => {
                    if (result !== undefined) {
                        resolve(result);
                    } else {
                        reject(false);
                    }
                })
                .catch(err => {
                    if (err.error.message !== undefined) {
                        if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        } else if (err.error.message.includes("Token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        } else if (err.error.message.includes("Nenhum produto encontrado")) {
                            Toast("error", "Nenhum produto encontrado");
                        } else if (err.error.message.includes("Network Error")) {
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                        }
                    } else {
                        Toast("error", "Falha ao consultar produtos.");
                    }
                    reject(false);
                })
        })
    }

    async function getPrePedido(id: number, history: any) {
        return new Promise((resolve, reject) => {
            consultarPrePedido(id === -1 ? "" : id, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(result => {
                    resolve(result instanceof Array ? result : [result]);
                })
                .catch(err => {
                    if (err.error.message !== undefined) {
                        if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            if (id === -1) {
                                redirectTo(history, '/login', { from: '/pedidos/consultar' });
                            } else {
                                redirectTo(history, '/login', { from: history.location.pathname });
                            }
                        } else if (err.error.message.includes("Token inválido")) {
                            if (id === -1) {
                                redirectTo(history, '/login', { from: '/pedidos/consultar' });
                            } else {
                                redirectTo(history, '/login', { from: history.location.pathname });
                            }
                        } else if (err.error.message.includes("Nenhum produto encontrado")) {
                            Toast("error", "Nenhum produto encontrado");
                        } else if (err.error.message.includes("Network Error")) {
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                        }
                    } else {
                        Toast("error", "Falha ao consultar produtos.");
                    }
                    reject([]);
                })
        })
    }

    async function deletarPrePedido(id: number, history: any) {
        return new Promise<boolean>((resolve, reject) => {
            excluirPrePedido(id, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(result => {
                    if (result !== undefined) {
                        setIdPrePedido(result.id);
                        resolve(true);
                    } else {
                        reject(false);
                    }
                })
                .catch(err => {
                    if (err.error.message !== undefined) {
                        if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        } else if (err.error.message.includes("Token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        } else if (err.error.message.includes("Nenhum produto encontrado")) {
                            Toast("error", "Nenhum produto encontrado");
                        } else if (err.error.message.includes("Network Error")) {
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                        }
                    } else {
                        Toast("error", "Falha ao consultar produtos.");
                    }
                    reject(false);
                })
        })
    }

    async function enviarPedidosPorEmail(pedidos: string[], enviacliente: boolean, history: any) {
        return new Promise<boolean>((resolve, reject) => {
            enviarEmailPedidos(pedidos, enviacliente, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(result => {
                    if (result !== undefined && result.status.toLowerCase() === "ok") {
                        resolve(true);
                    } else {
                        reject(false);
                    }
                })
                .catch(err => {
                    if (err.error.message !== undefined) {
                        if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        } else if (err.error.message.includes("Token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        } else if (err.error.message.includes("Nenhum produto encontrado")) {
                            Toast("error", "Nenhum produto encontrado");
                        } else if (err.error.message.includes("Network Error")) {
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                        }
                    } else {
                        Toast("error", "Falha ao consultar produtos.");
                    }
                    reject(false);
                })
        })
    }

    async function gerarResumoParaPrePedido(id: number, history: any) {
        return new Promise<ResumoPrePedido[]>((resolve, reject) => {
            gerarResumoPrePedido(id, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(result => {
                    resolve(result instanceof Array ? result : [result]);
                })
                .catch(err => {
                    if (err.error.message !== undefined) {
                        if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        } else if (err.error.message.includes("Token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        } else if (err.error.message.includes("Nenhum produto encontrado")) {
                            Toast("error", "Nenhum produto encontrado");
                        } else if (err.error.message.includes("Network Error")) {
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                        }
                    } else {
                        Toast("error", "Falha ao consultar produtos.");
                    }
                    reject([]);
                })
        })
    }

    async function enviarPedidoParaERP(id: number, history: any) {
        return new Promise<any>((resolve, reject) => {
            enviarPedidoERP(id, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(result => {
                    resolve(result instanceof Array ? result : [result]);
                })
                .catch(err => {
                    if (err.error !== undefined && err.error.message !== undefined) {
                        if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        } else if (err.error.message.includes("Nenhum produto encontrado")) {
                            Toast("error", "Nenhum produto encontrado");
                        } else if (err.error.message.includes("Network Error")) {
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e se os itens já foram enviados.");
                            reject("Falha na conexão de Rede, verifique sua internet e se os itens já foram enviados.");
                        }
                    } else {
                        Toast("error", "Falha ao enviar pedido.");
                    }
                    reject(err);
                })
        })
    }

    async function atualizaSaldoPrePedido(id: number, history: any) {
        return new Promise<any>((resolve, reject) => {
            verificaSaldoPrePedido(id, getFromSessionStorage("userlogin"), getFromSessionStorage("logid"))
                .then(result => {
                    resolve(result);
                })
                .catch(err => {
                    if (err.error.message !== undefined) {
                        if (err.error.message.includes("Credenciais inválidas") || err.error.message.includes("token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        } else if (err.error.message.includes("Token inválido")) {
                            redirectTo(history, '/login', { from: history.location.pathname });
                        } else if (err.error.message.includes("Nenhum produto encontrado")) {
                            Toast("error", "Nenhum produto encontrado");
                        } else if (err.error.message.includes("Network Error")) {
                            Toast("error", "Falha na conexão de Rede, verifique sua internet e atualize a página.");
                            reject("Falha na conexão de Rede, verifique sua internet e atualize a página.");
                        }
                    } else {
                        Toast("error", "Falha ao consultar saldo dos produtos.");
                    }
                    reject(undefined);
                })
        })
    }


    function redirectTo(history: any, pathname: string, state: { from: string }) {
        history.push({
            pathname: process.env.PUBLIC_URL + pathname,
            state: state
        })
    }

    return (
        <PedidosContext.Provider
            value={{
                novoPedido,
                pedido,
                loadingBuscaPedidosConsulta,
                pedidosBusca,
                situacoes,
                tiposPedidos,
                tiposFrete,
                itensDigitacaoPedido,
                idPrePedido,
                setPedidosBusca,
                updateResumoPrePedido,
                setIdPrePedido,
                setItensDigitacaoPedido,
                setNovoPedido,
                setPedido,
                buscarPedidos,
                setLoadingBuscaPedidosConsulta,
                buscarHistoricoPed,
                buscarItensPedido,
                buscarClientes,
                buscarFormaPGTO,
                buscarCondPGTO,
                buscarDerivacoes,
                filtrarProdutos,
                salvarPrePedido,
                updatePrePedido,
                getPrePedido,
                deletarPrePedido,
                gerarResumoParaPrePedido,
                enviarPedidoParaERP,
                buscarTransportadora,
                atualizaSaldoPrePedido,
                enviarPedidosPorEmail,
                filtrarPedidosAprovacao,
                controleAprovacao, 
                pendenciasPedidos               
            }}>
            {children}
        </PedidosContext.Provider>
    )
}

export function usePedidos() {
    const context = useContext(PedidosContext);
    if (!context) throw new Error("usePedidos must be used within an PedidosProvider");
    const {
        novoPedido,
        pedidosBusca,
        loadingBuscaPedidosConsulta,
        situacoes,
        tiposPedidos,
        tiposFrete,
        itensDigitacaoPedido,
        idPrePedido,
        setPedidosBusca,
        updateResumoPrePedido,
        setIdPrePedido,
        setItensDigitacaoPedido,
        buscarPedidos,
        buscarHistoricoPed,
        buscarItensPedido,
        buscarClientes,
        buscarFormaPGTO,
        buscarCondPGTO,
        setNovoPedido,
        buscarDerivacoes,
        filtrarProdutos,
        salvarPrePedido,
        updatePrePedido,
        getPrePedido,
        deletarPrePedido,
        gerarResumoParaPrePedido,
        enviarPedidoParaERP,
        buscarTransportadora,
        atualizaSaldoPrePedido,
        enviarPedidosPorEmail,
        filtrarPedidosAprovacao,
        controleAprovacao,
        pendenciasPedidos
    } = context;
    return ({
        novoPedido,
        pedidosBusca,
        loadingBuscaPedidosConsulta,
        situacoes,
        tiposPedidos,
        tiposFrete,
        itensDigitacaoPedido,
        idPrePedido,
        setPedidosBusca,
        updateResumoPrePedido,
        setIdPrePedido,
        setItensDigitacaoPedido,
        buscarPedidos,
        buscarHistoricoPed,
        buscarItensPedido,
        buscarClientes,
        buscarFormaPGTO,
        buscarCondPGTO,
        setNovoPedido,
        buscarDerivacoes,
        filtrarProdutos,
        salvarPrePedido,
        updatePrePedido,
        getPrePedido,
        deletarPrePedido,
        gerarResumoParaPrePedido,
        enviarPedidoParaERP,
        buscarTransportadora,
        atualizaSaldoPrePedido,
        enviarPedidosPorEmail,
        filtrarPedidosAprovacao,
        controleAprovacao,
        pendenciasPedidos
    });
}